module.exports = __webpack_public_path__ + "static/img/recommend.5a76ed78.png";